import React, { useEffect, useState, memo } from 'react';
import * as styles from 'src/uglib_styles/scavengerHuntBlock.module.css'

class Code {
  constructor(page, value, message) {
    this.page = page;
    this.value = value;
    this.message = message;
  }

  getPage() {
    return this.page;
  }

  getValue() {
    return this.value;
  }

  getMessage() {
    return this.message;
  }
}

const ScavengerHuntBlock = () => {
  const [value, setValue] = useState(null);
  const [message, setMessage] = useState(null);

  const codes = memo(new Map());
  codes['k3b7f'] = new Code('/writing-studying/studying-resources-workshops/', 'Studying', <p>We can help you develop exam prep skills and strategies. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>);

  useEffect(() => {
    // search codes for the value passed in the hunt parameter.
    const urlParams = new URLSearchParams(window.location.search);
    const hunt = urlParams.get('hunt');
    const code = codes[hunt];

    if (code) {
      if (window.location.pathname === code.getPage()) {
        setValue(code.getValue());
        setMessage(code.getMessage());
      }
    }
  }, [codes]);
  
  if (!value) {
    return <></>;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.header}>
          <span className={styles.icon + " fa-duotone fa-map-location"} />
          
        </div>
        <h2 className={styles.title}>You found it!</h2>
        <div className={styles.body}>
          <span className={styles.value_intro}>The secret code word is: </span>
          <span className={styles.value}>{value}</span>
          <div className={styles.message}>{message}</div>
        </div>
        
      </div>
    </div>
  );
};

export default ScavengerHuntBlock;
